import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { calculateLastActive } from 'utils/date';
import ScrollArea from 'react-scrollbar';
import Avatar from 'shared/components/avatar/Avatar';
import MessageList from './MessageList';
import MessageTyping from './MessageTyping';
import MessageOptions from './MessageOptions';
import {
  checkKickstart,
  getMessagesFirstPage,
  getMessagesPrevPage
} from './../ducks/messagesActions';

const MessageSide = ({
  checkKickstart,
  getMessagesFirstPage,
  getMessagesPrevPage,
  activeChat,
  chatPresets,
  isKickstartCompleted,
  currentPage,
  messages,
  isMessagesLoading,
  trainer,
  activeChatToggle
}) => {
  useEffect(() => {
    checkKickstart(activeChat.client.id);
    getMessagesFirstPage(activeChat.channel);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeChatToggle]);

  const sendMessage = (msg, attrs) => {
    activeChat.channel.sendMessage(msg, attrs);
  };

  return (
    <>
      <Avatar
        src={activeChat.client.photo || ''}
        width="32"
        height="32"
        name={`${activeChat.client.first_name} ${activeChat.client.last_name}`}
        firstLetters={`${activeChat.client.first_name[0].toUpperCase()}${activeChat.client.last_name[0].toUpperCase()}`}
        url={`/clients/${activeChat.client.id}`}
        text={
          activeChat.client.last_active
            ? `Last Active ${calculateLastActive(
                activeChat.client.last_active
              )} ago`
            : 'Invited to Hybrid'
        }
      />

      <MessageList
        messages={messages}
        isKickstartCompleted={isKickstartCompleted}
        currentPage={currentPage}
        getMessagesPrevPage={getMessagesPrevPage}
        trainer={trainer}
        isMessagesLoading={isMessagesLoading}
      />
      <MessageTyping sendMessage={sendMessage} />
      {chatPresets && (
        <ScrollArea className="message-options-area">
          <MessageOptions chatPresets={chatPresets} sendMessage={sendMessage} />
        </ScrollArea>
      )}
    </>
  );
};

function mapStateToProps(state) {
  return {
    isKickstartCompleted: state.messagesReducer.isKickstartCompleted,
    currentPage: state.messagesReducer.currentPage,
    messages: state.messagesReducer.messages,
    isMessagesLoading: state.messagesReducer.isMessagesLoading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    checkKickstart: clientId => dispatch(checkKickstart(clientId)),
    getMessagesFirstPage: channel => dispatch(getMessagesFirstPage(channel)),
    getMessagesPrevPage: page => dispatch(getMessagesPrevPage(page))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageSide);
